import React from 'react';
import { useCart } from '../context/CartContext';
import { CheckCircle, XCircle, ShoppingCart } from 'lucide-react';

const CartNotification = () => {
  const { notification, openCart } = useCart();

  if (!notification) return null;

  const isSuccess = notification.type === 'success';

  return (
    <div 
      className={`fixed bottom-6 right-6 z-[200] animate-slide-up cursor-pointer`}
      onClick={isSuccess ? openCart : undefined}
    >
      <div className={`flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg border ${
        isSuccess 
          ? 'bg-white border-green-200' 
          : 'bg-white border-red-200'
      }`}>
        {/* Icon */}
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
          isSuccess ? 'bg-green-100' : 'bg-red-100'
        }`}>
          {isSuccess ? (
            <CheckCircle className="h-6 w-6 text-green-600" />
          ) : (
            <XCircle className="h-6 w-6 text-red-600" />
          )}
        </div>
        
        {/* Content */}
        <div className="flex-1">
          <p className={`font-semibold text-sm ${
            isSuccess ? 'text-green-800' : 'text-red-800'
          }`}>
            {notification.message}
          </p>
          {notification.item && (
            <p className="text-xs text-gray-600 line-clamp-1">
              {notification.item.name}
            </p>
          )}
        </div>
        
        {/* Item Image (if available) */}
        {notification.item?.image && (
          <div className="w-12 h-12 rounded-lg overflow-hidden bg-gray-100 flex-shrink-0">
            <img 
              src={notification.item.image} 
              alt=""
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        )}
        
        {/* Cart Icon for success */}
        {isSuccess && (
          <div className="bg-[#004a80] p-2 rounded-full">
            <ShoppingCart className="h-5 w-5 text-white" />
          </div>
        )}
      </div>

      {/* Click hint for success notifications */}
      {isSuccess && (
        <p className="text-xs text-gray-500 text-center mt-1">
          Click to view cart
        </p>
      )}

      <style jsx>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default CartNotification;
